import { ReplaySubject } from 'rxjs/';
import { FormGroup } from '@angular/forms';
import { Component, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Observable, Scheduler, Subject } from 'rxjs';

import { RxComponent, ComponentEvent } from '../../../core/components/common/rx.component';

declare var $: any;
declare var confirmDatePlugin: any;

@Component({
    selector: 'itpx-reactive-input',
    templateUrl: './reactive-input.component.html',
    styleUrls: ['./reactive-input.component.css']
})
export class ReactiveInputComponent extends RxComponent implements AfterViewInit {

    private readonly DateFormat = 'dd MMM yyyy';
    private readonly DateTimeFormat = 'dd MMM yyyy, HH:mm';
    private readonly TimeFormat = 'HH:mm';

    @Input() name: string;
    @Input() form: FormGroup;
    @Input() config: any;
    @Input() dynamicConfig: any;

    @ViewChild('anchor') anchorElement;
    // Only if type is date
    @ViewChild('dateContainer') dateContainer;
    private picker: any;

    private top: number;
    private left: number;
    private isMin: boolean = true;

    private valueChange = new ReplaySubject<{ key: string, value: any }>(10);
    private pickerOpen = new Subject<any>();

    constructor() {
        super();
    }

    ngOnInit() {

        this.config.responsiveThreshold = this.config.responsiveThreshold || 1200;

        let afterViewInit = this.getLifecycle().skipWhile(e => e != ComponentEvent.AfterViewInit);

        // afterViewInit
        //     .flatMap(_ => Observable.fromEvent(window, 'resize').merge(Observable.of(true).delay(20)))
        //     .observeOn(Scheduler.queue)            
        //     .bindToLifecycle(this)
        //     .subscribe(_ => {
        //         this.isMin = document.body.clientWidth <= this.config.responsiveThreshold;
        //         if (!this.isMin) {
        //             let anchor = this.anchorElement.nativeElement;
        //             this.top = anchor.offsetTop;
        //             this.left = anchor.offsetLeft + anchor.offsetWidth;
        //         }
        //     });

        afterViewInit
            .delay(20)
            .flatMap(_ => this.valueChange)
            // .observeOn(Scheduler.queue)
            .bindToLifecycle(this)
            .subscribe(data => {
                switch (this.config.type) {
                    case 'date':
                        switch (data.key) {
                            case 'softMinDate':
                                this.pickerOpen
                                    .take(1)
                                    .bindToLifecycle(this)
                                    .subscribe(_ => this.picker.set('minDate', data.value));
                                break;
                            case 'softMaxDate':
                                this.pickerOpen
                                    .take(1)
                                    .bindToLifecycle(this)
                                    .subscribe(_ => this.picker.set('maxDate', data.value));
                                break;
                            case 'minDate': this.picker.set('minDate', data.value); break;
                            case 'maxDate': this.picker.set('maxDate', data.value); break;
                            case 'value': this.picker.setDate(data.value); break;
                            case 'disable': this.picker.set('disable', data.value); break;
                            case 'disabled': this.picker._input.setAttribute('disabled', data.value); break;
                        }

                        break;
                    case 'time':
                        switch (data.key) {
                            case 'value': this.picker.setDate(`${data.value.hours}:${data.value.mins}`); break;
                            case 'minDate': this.picker.set('minDate', data.value); break;
                            case 'disabled': this.picker._input.setAttribute('disabled', data.value); break;
                        }

                        break;
                }
            });
    }

    ngAfterViewInit() {
        switch (this.config.type) {
            case 'date':
                this.config.format = this.config.enableTime ? 'd M Y, H:i' : 'd M Y';
                this.picker = $(this.dateContainer.nativeElement).flatpickr({
                    animate: false,
                    dateFormat: this.config.format,
                    defaultHour: 12,
                    defaultMinute: 0,
                    time_24hr: true,
                    enableTime: this.config.enableTime,
                    plugins: [new confirmDatePlugin()],
                    wrap: true,
                    // onChange: (selected, dateStr, instance) => this.form.controls[this.name].setValue(selected[0]),
                    onOpen: () => this.pickerOpen.next(true)
                });

                break;
            case 'time':
                this.picker = $(this.dateContainer.nativeElement).flatpickr({
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true, // AM/PM time picker is used by default
                    defaultHour: 12,
                    defaultMinute: 0,
                    wrap: true,
                    // onChange: (selected, dateStr, instance) => this.form.controls[this.name].setValue(selected[0]),
                    onOpen: () => this.pickerOpen.next(true)
                });

                break;
        }

        super.ngAfterViewInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.picker) {
            this.picker.destroy();
        }
    }

    public set(key: string, value: any) {

        this.valueChange.next({ key: key, value: value });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/reactive-input/reactive-input.component.ts